import React from "react";
import { Link } from "react-router-dom";
import { Activity } from "lucide-react";
import { T } from "../context/LanguageContext";

export const Footer = () => (
  <footer className="border-t border-emerald-200 bg-emerald-50 text-slate-600" data-testid="footer">
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#0055FF] text-white">
              <Activity className="h-4 w-4" />
            </span>
            <span className="font-extrabold text-slate-900">SportsPulse.pro</span>
          </div>
          <p className="mt-3 text-sm text-slate-600"><T>Every Sport. Every Place. Everyone.</T></p>
          <p className="mt-4 font-script text-xl text-emerald-600">A More Active Brighter World</p>
        </div>
        <div>
          <h4 className="text-sm font-bold uppercase tracking-wider text-slate-900"><T>Explore</T></h4>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/sports" className="hover:text-emerald-700"><T>Sports & Games</T></Link></li>
            <li><Link to="/countries" className="hover:text-emerald-700"><T>Countries & Places</T></Link></li>
            <li><Link to="/teams" className="hover:text-emerald-700"><T>Teams & Leagues</T></Link></li>
            <li><Link to="/events" className="hover:text-emerald-700"><T>Events & Scores</T></Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-bold uppercase tracking-wider text-slate-900"><T>Learn</T></h4>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/schools" className="hover:text-emerald-700"><T>Schools & Colleges</T></Link></li>
            <li><Link to="/health" className="hover:text-emerald-700"><T>Sports Health</T></Link></li>
            <li><Link to="/halloffame" className="hover:text-emerald-700"><T>Halls of Fame</T></Link></li>
            <li><Link to="/news" className="hover:text-emerald-700"><T>News</T></Link></li>
            <li><Link to="/articles" className="hover:text-emerald-700"><T>Editorial Articles</T></Link></li>
            <li><Link to="/digest" className="hover:text-emerald-700"><T>Weekly Digest</T></Link></li>
            <li><Link to="/publications" className="hover:text-emerald-700"><T>Publications</T></Link></li>
            <li><Link to="/business" className="hover:text-emerald-700"><T>Sports Business</T></Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-bold uppercase tracking-wider text-slate-900"><T>Community</T></h4>
          <ul className="mt-3 space-y-2 text-sm">
            <li><Link to="/community" className="hover:text-emerald-700"><T>Forums & Groups</T></Link></li>
            <li><span className="text-slate-500"><T>Safeguarding first</T></span></li>
            <li><span className="text-slate-500"><T>Verified sources</T></span></li>
          </ul>
        </div>
      </div>
      <div className="mt-10 border-t border-emerald-200 pt-6 text-xs text-slate-500">
        <p><T>Demo portal with curated seed data. Health content is educational only — always consult qualified professionals. Paid promotion never changes verification, results or editorial judgment.</T></p>
        <p className="mt-2">© 2026 SportsPulse.pro</p>
      </div>
    </div>
  </footer>
);
